import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import Layout from "@/components/Layout";
import Modal from "@/components/Modal";
import { euro, productLabel } from "@/lib/format";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

const empty = {
  name: "", product_id: "", technique: "Stampa",
  position: "", color: "", size_variant: "",
  cost: 0, price: 0, note: "", image_url: "",
};

const TECHNIQUES = ["Stampa", "Ricamo", "Vinile", "Sublimazione", "Termoadesivo", "Applicazione strass"];

export default function Personalizzazioni() {
  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [q, setQ] = useState("");

  const load = async () => {
    const [k, p] = await Promise.all([api.get("/customizations"), api.get("/products")]);
    setRows(k.data); setProducts(p.data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(empty); setEditingId(null); setModal(true); };
  const openEdit = (r) => { setForm({ ...empty, ...r }); setEditingId(r.id); setModal(true); };
  const save = async () => {
    if (!form.name.trim()) return toast.error("Inserisci un nome per la personalizzazione");
    try {
      const body = { ...form, cost: +form.cost || 0, price: +form.price || 0 };
      if (editingId) await api.put(`/customizations/${editingId}`, body);
      else await api.post("/customizations", body);
      toast.success("Personalizzazione salvata"); setModal(false); load();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare la personalizzazione?")) return;
    await api.delete(`/customizations/${id}`); toast.success("Eliminata"); load();
  };

  const filtered = rows.filter((r) =>
    (r.name + " " + (r.technique || "") + " " + (r.position || "") + " " + (r.color || "")).toLowerCase().includes(q.toLowerCase())
  );

  return (
    <Layout topbarActions={
      <button className="btn accent" onClick={openNew} data-testid={IDS.newCustomizationBtn}>
        <i className="fa-solid fa-plus" /> Nuova personalizzazione
      </button>
    }>
      <div className="section-title">
        <div><h2>Personalizzazioni</h2><p>Cataloga stampe, ricami, applicazioni, colori e posizioni per prodotto.</p></div>
      </div>
      <div className="panel">
        <div className="panel-head">
          <div className="toolbar">
            <input placeholder="Cerca nome, tecnica, posizione o colore..." value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <button className="btn primary" onClick={openNew}><i className="fa-solid fa-plus" /> Aggiungi</button>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Nome</th><th>Prodotto collegato</th><th>Tecnica</th><th>Posizione</th><th>Colore</th><th>Taglia</th><th>Costo</th><th>Prezzo</th><th></th></tr></thead>
            <tbody data-testid="customizations-table-body">
              {filtered.length ? filtered.map((r) => (
                <tr key={r.id}>
                  <td><b>{r.name}</b><br /><small style={{ color: "var(--muted)" }}>{r.note || ""}</small></td>
                  <td>{r.product_id ? productLabel(products, r.product_id) : "—"}</td>
                  <td><span className="pill">{r.technique}</span></td>
                  <td>{r.position || "—"}</td>
                  <td>{r.color || "—"}</td>
                  <td>{r.size_variant || "—"}</td>
                  <td>{euro(r.cost)}</td>
                  <td>{euro(r.price)}</td>
                  <td style={{ display: "flex", gap: 6 }}>
                    <button className="btn small" onClick={() => openEdit(r)}><i className="fa-solid fa-pen" /></button>
                    <button className="btn small danger" onClick={() => del(r.id)}><i className="fa-solid fa-trash" /></button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={9} className="empty">Nessuna personalizzazione inserita.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} title={editingId ? "Modifica personalizzazione" : "Nuova personalizzazione"} onClose={() => setModal(false)} onSave={save}>
        <div className="form-grid">
          <div className="field full"><label>Nome / descrizione breve *</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="es. Nome atleta ricamato" data-testid="k-name" /></div>
          <div className="field"><label>Prodotto collegato</label>
            <select value={form.product_id} onChange={(e) => setForm({ ...form, product_id: e.target.value })}>
              <option value="">— nessuno —</option>
              {products.map((p) => <option key={p.id} value={p.id}>{p.code} — {p.name}</option>)}
            </select>
          </div>
          <div className="field"><label>Tecnica</label>
            <select value={form.technique} onChange={(e) => setForm({ ...form, technique: e.target.value })}>
              {TECHNIQUES.map((t) => <option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="field"><label>Posizione</label><input value={form.position} onChange={(e) => setForm({ ...form, position: e.target.value })} placeholder="Petto, schiena, manica..." /></div>
          <div className="field"><label>Colore</label><input value={form.color} onChange={(e) => setForm({ ...form, color: e.target.value })} /></div>
          <div className="field"><label>Taglia di riferimento</label><input value={form.size_variant} onChange={(e) => setForm({ ...form, size_variant: e.target.value })} placeholder="es. XS, 8, 10..." /></div>
          <div className="field"><label>Costo lavorazione</label><input type="number" step="0.01" min="0" value={form.cost} onChange={(e) => setForm({ ...form, cost: e.target.value })} /></div>
          <div className="field"><label>Prezzo al pubblico</label><input type="number" step="0.01" min="0" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} /></div>
          <div className="field full"><label>URL immagine (opzionale)</label><input value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} placeholder="https://..." /></div>
          <div className="field full"><label>Note</label><textarea rows="3" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} /></div>
        </div>
      </Modal>
    </Layout>
  );
}
